import { Typography } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";

export const UserInfo = () => {
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();

  const getRoleString = (): string => {
    if (!userSession) {
      return "";
    }

    switch (userSession.roleId) {
      case RoleEnum.ASOO:
        return t("common.ASOO");
      case RoleEnum.MZOM:
        return t("common.MZO");
      case RoleEnum.Helpdesk:
        return t("common.Helpdesk");
      case RoleEnum.ASOOAdmin:
        return t("common.ASOOManager");
      case RoleEnum.MZOMAdmin:
        return t("common.MZOManager");
      case RoleEnum.ASOOOffice:
        return t("common.ASOOOffice");
      case RoleEnum.MZOMOffice:
        return t("common.MZOOffice");  
      default:
        return "";
    }
  }

  const getUserString =(): string => {
    if (!userSession) {
      return "";
    }

    let result = '';
    const roleString = getRoleString();
    if (roleString) {
      result += roleString + ", "
    }
    
    result += userSession.name + ", " + userSession.oib
    return result;
  }

  return (
    <>
      {userSession && 
        <Typography component="h2">
        {getUserString()}
        </Typography>
      }
    </>
  );
}